import { PayloadAction } from '@reduxjs/toolkit';
import { validate } from 'main/store/_utils/reducer';
import { VideosState, videoSchema, Privacy, privacySchema, titleSchema, descriptionSchema, VideoData } from '../../state';


export const changeSharedVideoFormPrivacy = (state: VideosState, action: PayloadAction<Privacy>) => {
    state.form.shared.privacy.value = action.payload;
    state.form.shared.privacy.errors = validate(privacySchema, action.payload);
}

export const changeSharedVideoFormTitle = (state: VideosState, action: PayloadAction<string>) => {
    state.form.shared.title.value = action.payload;
    state.form.shared.title.errors = validate(titleSchema, action.payload);
}

export const changeSharedVideoFormDescription = (state: VideosState, action: PayloadAction<string>) => {
    state.form.shared.description.value = action.payload;
    state.form.shared.description.errors = validate(descriptionSchema, action.payload);
}

export const changeSharedVideoFormVideoData = (state: VideosState, action: PayloadAction<VideoData | null>) => {
    state.form.shared.video.value = action.payload;
    state.form.shared.video.errors = validate(videoSchema, action.payload);
}
